export default __webpack_public_path__ + "static/media/10.76603bb8.jpg";